import { useRef } from 'react';

interface CameraCaptureInputProps {
  onCapture: (file: File) => void;
  /** When true, opens the gallery/file picker instead of forcing the camera. */
  galleryMode?: boolean;
  children: React.ReactNode;
  className?: string;
}

/**
 * `<input type="file" accept="image/*" capture="environment">` opens the
 * device's native camera app directly on mobile browsers (iOS Safari,
 * Android Chrome) — far more reliable across devices than driving a raw
 * `getUserMedia` viewfinder ourselves, and the native camera UI already
 * gives the user focus/exposure controls we'd otherwise have to rebuild.
 */
export default function CameraCaptureInput({ onCapture, galleryMode = false, children, className }: CameraCaptureInputProps) {
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <>
      <button type="button" className={className} onClick={() => inputRef.current?.click()}>
        {children}
      </button>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        capture={galleryMode ? undefined : 'environment'}
        className="hidden"
        onChange={(e) => {
          const file = e.target.files?.[0];
          e.target.value = '';
          if (file) onCapture(file);
        }}
      />
    </>
  );
}
